/** Panel menü / alt sayfa erişim anahtarları — admin dışı kullanıcılar için */

export const PANEL_MENU_PERMISSION_GROUPS = [
  {
    id: "call-center",
    label: "Çağrı Merkezi",
    items: [
      { key: "menu_cdr", label: "Çağrı Kayıtları" },
      { key: "menu_search", label: "GSM Arama", note: "Ayrıca GSM arama yetkisi gerekir" },
      { key: "menu_transcripts", label: "Transkriptler", note: "Ayrıca ses kaydı yetkisi gerekir" },
      { key: "menu_lines_settings", label: "Hat Ayarları" },
      { key: "menu_lines_routing", label: "Yönlendirme" },
      { key: "menu_agents", label: "Agentlar menüsü" },
      { key: "menu_agents_list", label: "Agent Listesi" },
      { key: "menu_agents_attendance", label: "Mesai Takibi" },
      { key: "menu_devices", label: "Cihazlar" },
    ],
  },
  {
    id: "crm",
    label: "CRM",
    items: [
      { key: "menu_crm", label: "CRM menüsü" },
      { key: "menu_crm_customers", label: "Müşteriler" },
      { key: "menu_crm_data_transfer", label: "Data Aktarımı" },
    ],
  },
  {
    id: "reports",
    label: "Raporlar",
    items: [
      { key: "menu_reports", label: "Raporlar menüsü" },
      { key: "menu_reports_agents", label: "Agent Görüşme Raporu" },
      { key: "menu_reports_mesai", label: "Mesai Raporları" },
      { key: "menu_reports_mola", label: "Mola Raporları" },
      { key: "menu_reports_tl_recordings", label: "Tk. Liderleri Ses Kayıtları" },
      { key: "menu_reports_special_agent", label: "Özel Asistan Raporu", note: "Agent bazlı 6 rapor tek ekran" },
      { key: "menu_reports_tl_performance", label: "Takım Lideri Performansları", note: "TL bazlı 6+ modül rapor kümesi" },
      { key: "menu_reports_tl_approval", label: "Tk Lideri Onayı", note: "TL ses kayıt raporunda ASK/TKSK onay alanları" },
      { key: "menu_reports_mgr_tl_yeni_asistan", label: "Takım lideri Yeni Asistan Raporu", note: "Yönetici raporları" },
      { key: "menu_reports_mgr_kalite_degerlendirme", label: "Kalite Değerlendirme Raporu", note: "Yönetici raporları" },
      { key: "menu_reports_mgr_yeni_asistan_kalite", label: "Yeni Asistan Kalite Değerlendirme Raporu", note: "Yönetici raporları" },
    ],
  },
  {
    id: "other",
    label: "Diğer",
    items: [
      { key: "menu_work_schedules", label: "Mesai Planları", note: "Agent yönetimi veya admin gerekir" },
      { key: "menu_todos", label: "To-Do List" },
    ],
  },
];

export const ALL_PANEL_MENU_PERMISSION_KEYS = PANEL_MENU_PERMISSION_GROUPS.flatMap((g) =>
  g.items.map((i) => i.key)
);

export const REPORT_VIEW_IDS = [
  "agents", "mesai", "mola", "tl-recordings", "special-agent",
  "mgr-tl-yeni-asistan", "mgr-kalite-degerlendirme", "mgr-yeni-asistan-kalite",
];

/** Rapor görünümü → yetki anahtarı (agents id'si menu_agents ile karışmasın diye açık eşleme) */
export const REPORT_VIEW_PERMISSION_KEYS = {
  agents: "menu_reports_agents",
  mesai: "menu_reports_mesai",
  mola: "menu_reports_mola",
  "tl-recordings": "menu_reports_tl_recordings",
  "special-agent": "menu_reports_special_agent",
  "mgr-tl-yeni-asistan": "menu_reports_mgr_tl_yeni_asistan",
  "mgr-kalite-degerlendirme": "menu_reports_mgr_kalite_degerlendirme",
  "mgr-yeni-asistan-kalite": "menu_reports_mgr_yeni_asistan_kalite",
};

export const REPORT_MENU_CHILD_KEYS = [
  ...Object.values(REPORT_VIEW_PERMISSION_KEYS),
  "menu_reports_tl_approval",
  "menu_reports_tl_performance",
];

export const AGENTS_MENU_CHILD_KEYS = ["menu_agents_list", "menu_agents_attendance"];

export const CRM_VIEW_PERMISSION_KEYS = {
  customers: "menu_crm_customers",
  "data-transfer": "menu_crm_data_transfer",
};

export const CRM_MENU_CHILD_KEYS = Object.values(CRM_VIEW_PERMISSION_KEYS);

export const buildDefaultPanelMenuPermissions = (value = 1) =>
  ALL_PANEL_MENU_PERMISSION_KEYS.reduce((acc, key) => {
    acc[key] = value;
    return acc;
  }, {});

/** Görev bazlı hızlı şablonlar — mevcut ana yetkiler korunur, sayfa erişimi atanır */
export const PANEL_MENU_PRESETS = {
  dataci: {
    label: "Datacı",
    permissions: {
      menu_cdr: 1,
      menu_search: 1,
      menu_transcripts: 1,
      menu_crm: 1,
      menu_crm_customers: 1,
      menu_crm_data_transfer: 1,
      menu_reports: 1,
      menu_reports_agents: 1,
      menu_reports_mesai: 1,
      menu_reports_mola: 1,
      menu_reports_tl_recordings: 1,
      menu_lines_settings: 0,
      menu_lines_routing: 0,
      menu_agents: 1,
      menu_agents_list: 1,
      menu_agents_attendance: 0,
      menu_devices: 1,
      menu_work_schedules: 0,
      menu_todos: 0,
    },
  },
  takim_lideri: {
    label: "Takım Lideri",
    permissions: {
      menu_cdr: 1,
      menu_search: 1,
      menu_transcripts: 1,
      menu_crm: 1,
      menu_crm_customers: 1,
      menu_crm_data_transfer: 1,
      menu_reports: 1,
      menu_reports_agents: 1,
      menu_reports_mesai: 1,
      menu_reports_mola: 1,
      menu_reports_tl_recordings: 1,
      menu_lines_settings: 0,
      menu_lines_routing: 0,
      menu_agents: 1,
      menu_agents_list: 1,
      menu_agents_attendance: 1,
      menu_devices: 1,
      menu_work_schedules: 0,
      menu_todos: 0,
    },
  },
  kalite: {
    label: "Kalite",
    permissions: {
      menu_cdr: 1,
      menu_search: 1,
      menu_transcripts: 1,
      menu_crm: 0,
      menu_crm_customers: 0,
      menu_reports: 1,
      menu_reports_agents: 1,
      menu_reports_mesai: 0,
      menu_reports_mola: 1,
      menu_reports_tl_recordings: 1,
      menu_reports_tl_approval: 1,
      menu_lines_settings: 0,
      menu_lines_routing: 0,
      menu_agents: 1,
      menu_agents_list: 1,
      menu_agents_attendance: 0,
      menu_devices: 0,
      menu_work_schedules: 0,
      menu_todos: 0,
    },
  },
  asistan: {
    label: "Asistan",
    permissions: {
      menu_cdr: 1,
      menu_search: 0,
      menu_transcripts: 1,
      menu_crm: 0,
      menu_crm_customers: 0,
      menu_reports: 0,
      menu_reports_agents: 0,
      menu_reports_mesai: 0,
      menu_reports_mola: 0,
      menu_lines_settings: 0,
      menu_lines_routing: 0,
      menu_agents: 0,
      menu_agents_list: 0,
      menu_agents_attendance: 0,
      menu_devices: 0,
      menu_work_schedules: 0,
      menu_todos: 0,
    },
  },
  call_center_yonetici: {
    label: "Call Center Yönetici",
    permissions: {
      menu_cdr: 1, menu_search: 1, menu_transcripts: 1,
      menu_crm: 1, menu_crm_customers: 1, menu_crm_data_transfer: 0,
      menu_reports: 1, menu_reports_agents: 1, menu_reports_mesai: 1, menu_reports_mola: 1, menu_reports_tl_recordings: 1,
      menu_reports_mgr_tl_yeni_asistan: 1,
      menu_reports_mgr_kalite_degerlendirme: 1,
      menu_reports_mgr_yeni_asistan_kalite: 1,
      menu_lines_settings: 0, menu_lines_routing: 0,
      menu_agents: 1, menu_agents_list: 1, menu_agents_attendance: 1, menu_devices: 1,
      menu_work_schedules: 1, menu_todos: 0,
    },
  },
  muhasebe: {
    label: "Muhasebe",
    permissions: {
      menu_cdr: 1, menu_search: 0, menu_transcripts: 0,
      menu_crm: 0, menu_crm_customers: 0, menu_crm_data_transfer: 0,
      menu_reports: 1, menu_reports_agents: 1, menu_reports_mesai: 1, menu_reports_mola: 0, menu_reports_tl_recordings: 0,
      menu_lines_settings: 0, menu_lines_routing: 0,
      menu_agents: 1, menu_agents_list: 1, menu_agents_attendance: 0, menu_devices: 0,
      menu_work_schedules: 0, menu_todos: 0,
    },
  },
  yonetici: {
    label: "Yönetici (Geniş)",
    permissions: buildDefaultPanelMenuPermissions(1),
  },
  minimal: {
    label: "Sadece CDR",
    permissions: {
      ...buildDefaultPanelMenuPermissions(0),
      menu_cdr: 1,
    },
  },
};

const toPermissionFlag = (value) => (value === 1 || value === true || value === "1" ? 1 : 0);

export const normalizePanelMenuPermissions = (raw, { defaultValue = 1 } = {}) => {
  const base = buildDefaultPanelMenuPermissions(defaultValue);
  if (!raw || typeof raw !== "object") return null;
  const out = { ...base };
  ALL_PANEL_MENU_PERMISSION_KEYS.forEach((key) => {
    if (raw[key] !== undefined && raw[key] !== null) {
      out[key] = toPermissionFlag(raw[key]);
    }
  });
  return syncPanelMenuPermissionParents(out);
};

/** Kayıtlı kullanıcı — eksik anahtarlar 0 kabul edilir (menu_agents raporları etkilemesin) */
export const getEffectivePanelMenuPermissions = (user) => {
  if (!user?.panel_menu_permissions || typeof user.panel_menu_permissions !== "object") return null;
  if (Object.keys(user.panel_menu_permissions).length === 0) return null;
  return normalizePanelMenuPermissions(user.panel_menu_permissions, { defaultValue: 0 });
};

export const syncPanelMenuPermissionParents = (perms) => {
  const next = { ...perms };
  next.menu_reports = REPORT_MENU_CHILD_KEYS.some((key) => next[key] === 1) ? 1 : 0;
  next.menu_agents = AGENTS_MENU_CHILD_KEYS.some((key) => next[key] === 1) ? 1 : 0;
  next.menu_crm = CRM_MENU_CHILD_KEYS.some((key) => next[key] === 1) ? 1 : 0;
  return next;
};

export const applyPanelMenuPermissionToggle = (prev, key, checked) => {
  const next = { ...prev, [key]: checked ? 1 : 0 };

  if (key === "menu_reports") {
    REPORT_MENU_CHILD_KEYS.forEach((childKey) => {
      next[childKey] = checked ? 1 : 0;
    });
  } else if (REPORT_MENU_CHILD_KEYS.includes(key)) {
    next.menu_reports = REPORT_MENU_CHILD_KEYS.some((childKey) => next[childKey] === 1) ? 1 : 0;
  }

  if (key === "menu_agents") {
    AGENTS_MENU_CHILD_KEYS.forEach((childKey) => {
      next[childKey] = checked ? 1 : 0;
    });
  } else if (AGENTS_MENU_CHILD_KEYS.includes(key)) {
    if (checked) next.menu_agents = 1;
    else if (!AGENTS_MENU_CHILD_KEYS.some((childKey) => next[childKey] === 1)) next.menu_agents = 0;
  }

  if (key === "menu_crm") {
    CRM_MENU_CHILD_KEYS.forEach((childKey) => {
      next[childKey] = checked ? 1 : 0;
    });
  } else if (CRM_MENU_CHILD_KEYS.includes(key)) {
    next.menu_crm = CRM_MENU_CHILD_KEYS.some((childKey) => next[childKey] === 1) ? 1 : 0;
  }

  return syncPanelMenuPermissionParents(next);
};

export const finalizePanelMenuPermissions = (raw) => {
  const normalized = normalizePanelMenuPermissions(raw, { defaultValue: 0 });
  if (!normalized) return buildDefaultPanelMenuPermissions(0);
  return syncPanelMenuPermissionParents(normalized);
};

/** null/undefined = eski kullanıcılar → tam erişim */
export const hasPanelMenuPermission = (user, key) => {
  if (!user) return false;
  if (user.is_admin === 1 || user.is_super_admin === 1) return true;
  const perms = getEffectivePanelMenuPermissions(user);
  if (perms === null) return true;
  return perms[key] === 1;
};

export const getReportViewPermissionKey = (viewId) =>
  REPORT_VIEW_PERMISSION_KEYS[viewId] || `menu_reports_${viewId}`;

export const getCrmViewPermissionKey = (viewId) =>
  CRM_VIEW_PERMISSION_KEYS[viewId] || "menu_crm_customers";

export const hasAnyReportMenuPermission = (user) =>
  REPORT_MENU_CHILD_KEYS.some((key) => hasPanelMenuPermission(user, key));

export const getAgentsViewPermissionKey = (viewId) =>
  viewId === "list" || viewId === "attendance" ? `menu_agents_${viewId}` : "menu_agents";

export const getLinesViewPermissionKey = (viewId) => `menu_lines_${viewId}`;

export const isPanelMenuPermissionsConfigured = (user) => {
  if (!user?.panel_menu_permissions || typeof user.panel_menu_permissions !== "object") return false;
  return Object.keys(user.panel_menu_permissions).length > 0;
};

/** Kullanıcı tablosu — ana yetki rozetleri */
export const USER_CORE_PERMISSION_BADGES = [
  { key: "ses_kaydi_goster", label: "Ses", title: "Ses kaydı görüntüleme" },
  { key: "arama_yetkisi", label: "GSM", title: "GSM arama yapabilir" },
  { key: "agent_analiz_yetkisi", label: "Analiz", title: "Agent analizi görüntüleme" },
  { key: "agent_yonetimi", label: "Agent", title: "Agent yönetimi" },
  { key: "excel_indirme", label: "Excel", title: "Excel indirme" },
  { key: "softphone_yetkisi", label: "Softphone", title: "Softphone kullanımı" },
  { key: "kullanici_yonetimi", label: "Kullanıcı", title: "Kullanıcı yönetimi" },
  { key: "firma_yonetimi", label: "Firma", title: "Firma kapsamlı yönetim (tüm agent/veri + firma ayarları)" },
];

/** Kullanıcı tablosu — sayfa erişim rozetleri (kısa etiketler) */
export const USER_MENU_PERMISSION_BADGES = [
  { key: "menu_cdr", label: "CDR", title: "Çağrı Kayıtları" },
  { key: "menu_search", label: "GSM A.", title: "GSM Arama sayfası" },
  { key: "menu_transcripts", label: "Transkript", title: "Transkriptler" },
  { key: "menu_crm_customers", label: "CRM", title: "CRM / Müşteriler" },
  { key: "menu_crm_data_transfer", label: "Data A.", title: "CRM / Data Aktarımı" },
  { key: "menu_reports_agents", label: "Görüşme R.", title: "Agent Görüşme Raporu" },
  { key: "menu_reports_mesai", label: "Mesai R.", title: "Mesai Raporları" },
  { key: "menu_reports_mola", label: "Mola R.", title: "Mola Raporları" },
  { key: "menu_lines_settings", label: "Hat", title: "Hat Ayarları" },
  { key: "menu_lines_routing", label: "Yönlendirme", title: "Hat yönlendirme" },
  { key: "menu_agents_list", label: "Agent L.", title: "Agent Listesi" },
  { key: "menu_agents_attendance", label: "Mesai T.", title: "Mesai Takibi" },
  { key: "menu_devices", label: "Cihaz", title: "Cihazlar" },
  { key: "menu_work_schedules", label: "Mesai P.", title: "Mesai Planları" },
  { key: "menu_todos", label: "To-Do", title: "To-Do List" },
];

export const getUserCorePermissionBadges = (user) => {
  if (!user) return [];
  if (user.is_admin === 1 || user.is_super_admin === 1) {
    return [{ id: "admin-all", label: "Tam yetki", title: "Admin — tüm ana yetkiler" }];
  }
  return USER_CORE_PERMISSION_BADGES.filter((item) => user[item.key] === 1).map((item) => ({
    id: item.key,
    label: item.label,
    title: item.title,
  }));
};

export const getUserMenuPermissionBadges = (user) => {
  if (!user) return [];
  if (user.is_admin === 1 || user.is_super_admin === 1) {
    return [{ id: "menu-all", label: "Tüm sayfalar", title: "Admin — tüm menü ve alt sayfalar" }];
  }
  if (!isPanelMenuPermissionsConfigured(user)) {
    return [{ id: "menu-legacy", label: "Varsayılan", title: "Özel sayfa kısıtı yok — tam menü erişimi" }];
  }
  const perms = normalizePanelMenuPermissions(user.panel_menu_permissions);
  return USER_MENU_PERMISSION_BADGES.filter((item) => perms[item.key] === 1).map((item) => ({
    id: item.key,
    label: item.label,
    title: item.title,
  }));
};

export const getUserMenuPermissionSummary = (user) => {
  const badges = getUserMenuPermissionBadges(user);
  if (badges.length === 0) return "Sayfa erişimi tanımlı değil";
  if (badges.length === 1 && (badges[0].id === "menu-all" || badges[0].id === "menu-legacy")) {
    return badges[0].title;
  }
  return badges.map((b) => b.label).join(", ");
};
